import React, {useState } from 'react'
import GoogleMapReact from 'google-map-react'
import { Icon } from '@iconify/react'
import locationIcon from '@iconify/icons-mdi/map-marker'
//import '../assets/css/maps.css'
import Marker from './Marker';
import Select from 'react-select';


const GoogleMap = ({ newsCategory }) => {


  const defaultProps = {
    center: {
      lat: 52.707675273639175,
      lng:-0.4100171796874208,
    },
    zoom: 7,
  }
  const location = {
    lat: 52.734043,
    lng: -0.802705,
  }


  const LocationPin = ({ text }) => (
    <div className="pin">
      <Icon icon={locationIcon} className="pin-icon" />
      <p className="pin-text">{text}</p>
    </div>
  )

  const mapMarkers = [{lat: "51.068785",lng: "-1.794472",name:"Salisbury, UK",image:"map-pin-residential.png"},{lat: "53.382938",lng: "-1.466576",name:"High Street, Sheffield, UK",image:"map-pin-commercial.png"},{lat:"51.072964",lng: "1.135966",name:"West Lawn Gardens, Sandgate, Folkestone, UK",image:"map-pin-residential.png"},{lat:"51.400766",lng: "-0.356295",name:"Molesey, East Molesey, UK",image:"map-pin-commercial.png"},{lat: "51.428825",lng: "-0.547876",name:"Egham, UK",image:"map-pin-residential.png"},{lat: "51.474019",lng: "-0.166988",name:"Bridge Lane, London, UK",image:"map-pin-residential.png"},{lat: "51.512514",lng: "0.012284",name:"Shirley Street, London, UK",image:"map-pin-commercial.png"},{lat: "52.534951",lng: "1.476249",name:"George Lane, Loddon, Norwich, UK",image:"map-pin-residential.png"},{lat: "50.733557",lng: "-0.791052",name:"High Street, Selsey, Chichester, UK",image:"map-pin-residential.png"},{lat: "51.507351",lng: "-0.127758",name:"London, UK",image:"map-pin-residential.png"},{lat: "51.365549",lng: "-0.438114",name:"Queens Road, Weybridge, Walton-on-Thames, UK",image:"map-pin-commercial.png"},{lat: "54.249218",lng: "-1.054784",name:"Swanland Road, Helmsley, York, UK",image:"map-pin-residential.png"},{lat: "51.060853",lng: "0.165894",name:"Crowborough, UK",image:"map-pin-residential.png"},{lat: "51.524793",lng: "-0.233636",name:"Scrubs Lane, London, UK",image:"map-pin-commercial.png"},{lat: "51.160828",lng: "-1.088933",name:"Lower Wield, Alresford, UK",image:"map-pin-residential.png"},{lat: "51.407796",lng: "0.525506",name:"Upnor, Rochester, UK",image:"map-pin-residential.png"},{lat: "50.966414",lng: "0.095913",name:"Uckfield, UK",image:"map-pin-commercial.png"},{lat: "51.183917",lng: "-0.524762",name:"Shamley Green, Guildford, UK",image:"map-pin-residential.png"},{lat: "53.732320",lng: "-0.428609",name:"Astral Close, Hessle, UK",image:"map-pin-residential.png"},{lat: "51.473047",lng: "-0.055056",name:"Queen's Road, London, UK",image:"map-pin-commercial.png"},{lat: "52.473197",lng: "1.514031",name:"Kell's Way, Geldeston, Beccles, UK",image:"map-pin-residential.png"},{lat: "54.525004",lng: "-1.557559",name:"Skinnergate, Darlington, UK",image:"map-pin-commercial.png"},{lat: "52.481556",lng: "-1.899357",name:"Colmore Row, Birmingham, UK",image:"map-pin-commercial.png"},{lat: "50.925836",lng: "-1.792526",name:"Fordingbridge, UK",image:"map-pin-residential.png"},{lat: "51.942183",lng: "0.649319",name:"Colchester Road, Halstead, UK",image:"map-pin-residential.png"},{lat: "51.440964",lng: "-0.186949",name:"Garratt Lane, London, UK",image:"map-pin-residential.png"},{lat: "50.925836",lng: "-1.792526",name:"Fordingbridge, UK",image:"map-pin-residential.png"}]

  const [mapMarkerObjects, setMapMarkerObjects] = useState(mapMarkers)

  const customStyles = {
    option: (provided,selectedOption) => ({
      ...provided,
      color: selectedOption ? "#041e41" : "#041e41",
      backgroundColor: '#fff',
      fontSize: '22px',
      fontWeight: '200',
    }),
    control: (provided,selectedOption) => ({
      ...provided,
      backgroundColor: '#041e41',
      border: '0px',
      borderRadius: '30px',
      marginLeft:'10px'
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'white',
      backgroundColor: '#041e41',
      fontSize: '22px',
      fontWeight: '200',
      padding: '0 7px 0 7px',

    }),
  }

  const newMarkerItems = []
  const handleSelect=(e)=>{
    const newMarkerItems = []
    
    if(e.label==="Filter by category"){
      mapMarkers.map(items =>
          newMarkerItems.push({
            lat: items.lat,
            lng: items.lng,
            name: items.name,
            image:items.image,
          })
        )
    }
    else{
    mapMarkers.map(items => items.image === e.value ? (
        newMarkerItems.push({
          lat: items.lat,
          lng: items.lng,
          name: items.name,
          image:items.image,
        })
        ) : (
          null
        ))
    }
  setMapMarkerObjects(newMarkerItems)
  }
  const filterTitles = [{value: "Filter by category",label: "Filter by category"},{label: "Residential funding",value: "map-pin-residential.png"},{label: "Commercial funding",value: "map-pin-commercial.png"}]


  return (
  <>
  <div className="full-width-flex-container">
  <div className="full-half-flex-container very-light-blue-background">
      <div className="map-filter-dropdown-container clearfix">
      <Select styles = { customStyles } options={filterTitles} defaultValue={filterTitles[0]} onChange={handleSelect} multi />
      </div>
    </div>
  <div className="full-half-flex-container very-light-blue-background">
    <div className="map-key-holder clearfix">
      <div className="map-key">Key:</div>
      <div className="map-resi">Residential</div>
      <div className="map-comm">Commercial</div>
    </div>
  </div>
</div>

<section className="content navy-background">
<div className="contact-map-holder scroll-to-filter clearfix">

  <div style={{ height: '600px', width: '100%' }}>
    <GoogleMapReact
      // bootstrapURLKeys={{ key: 'AlzaSyBRKoTpCZsUXfcXyxHxoK-PpXMHYwfqs8o' }}
      //localhost bootstrapURLKeys={{ key: 'AIzaSyDhWe-Qxif2PBNdyVQlGZvkzi8R4CBsIJY' }}
      bootstrapURLKeys={{ key: 'AIzaSyAotFAmeO5idIxPDK38NNKoexhQufZK93M' }}

      defaultCenter={defaultProps.center}
      defaultZoom={defaultProps.zoom}

      //options={{ styles: [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"color":"#000000"},{"lightness":13}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#144b53"},{"lightness":14},{"weight":1.4}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#08304b"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#0c4152"},{"lightness":5}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#0b434f"},{"lightness":25}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#000000"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#0b3d51"},{"lightness":16}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"}]},{"featureType":"transit","elementType":"all","stylers":[{"color":"#146474"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#021019"}]}] }}
      options={{ styles: [{
      "featureType":"all","elementType":"labels.text.fill",
      "stylers":[{"color":"#444444"}]},
      {"featureType":"landscape","elementType":"all",
      "stylers":[{"color":"#f2f2f2"}]},
      {"featureType":"poi","elementType":"all",
      "stylers":[{"visibility":"off"},{"lightness":5}]},
      {"featureType":"road","elementType":"all",
      "stylers":[{"saturation":"-100"},{"lightness":45}]},
      {"featureType":"road.highway","elementType":"all",
      "stylers":[{"visibility":"simplified"}]},
      {"featureType":"road.arterial","elementType":"labels.icon",
      "stylers":[{"visibility":"off"}]},
      {"featureType":"transit","elementType":"all",
      "stylers":[{"visibility":"off"}]},
      {"featureType":"water","elementType":"all","stylers":[{"color":"#c1bfbf"},{"visibility":"on"}]}] }}
    >

    {mapMarkerObjects.length
      ? mapMarkerObjects.map((marker,index) => (
        //console.log(marker.lat)
        <Marker
                lat={marker.lat}
                lng={marker.lng}
                name={marker.name}
                image={marker.image}
                tooltip={marker.name}
              >

              </Marker>
      ))
    : null
    }



    </GoogleMapReact>
  </div>
  </div>
  </section>
  </>)
}

export default GoogleMap
